import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OverviewSection.css';

import flyerImage from '../Assets/storyfest/flyer2.jpeg'; 

const OverviewSection = () => {
  const navigate = useNavigate();

  const features = [
    { num: '01', title: 'Books & stories', desc: 'Meet authors and hear tales that stay with you.' },
    { num: '02', title: 'Made in Ghana', desc: 'Explore the makers, brands and craft behind the culture.' },
    { num: '03', title: 'Food & flavour', desc: 'Follow the aroma to familiar favourites and new finds.' },
    { num: '04', title: 'Creative play', desc: 'Make, paint, learn and try something together.' },
    { num: '05', title: 'Places to go', desc: 'Discover more of Ghana and the journeys it inspires.' },
    { num: '06', title: 'Live moments', desc: 'Dance, music and Believe, the grand indoor Christmas musical.' },
  ];

  return (
    <section id="overview" className="storyfest-overview-section">
      <div className="storyfest-container">
        
        {/* =========================================
            TOP HEADER & TEXT
            ========================================= */}
        <div className="storyfest-overview-top-header">
          <div className="storyfest-header-left">
            <p className="storyfest-top-label">01 / THE EXPERIENCE</p>
          </div>
          <div className="storyfest-header-right">
            <p className="storyfest-top-label">STORIES · CULTURE · CREATIVITY</p>
          </div>
        </div>

        <div className="storyfest-overview-main-split">
          {/* LEFT: Editorial Text */}
          <div className="storyfest-overview-text-content">
            <p className="storyfest-pre-title">A THREE-DAY FAMILY FESTIVAL</p>
            <h2 className="storyfest-hero-title-overview">
              <span className="storyfest-text-blue">A whole world</span><br/>
              <span className="storyfest-text-gold-italic">of stories.</span>
            </h2>
            
            <p className="storyfest-overview-description">
              StoryFest brings Ghanaian stories, culture and creativity together in one place. 
              Come to discover Ghana, have fun, shop, learn and connect.
            </p>
          </div>

          {/* RIGHT: Flyer Display */}
          <div className="storyfest-overview-right-content">
            <div className="storyfest-flyer-wrapper">
              <img src={flyerImage} alt="StoryFest Official Flyer" className="storyfest-flyer-img" />
              
            </div>
          </div>
        </div>

        {/* =========================================
            BOTTOM GRID: Features
            ========================================= */}
        <div className="storyfest-overview-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="storyfest-feature-item">
              <div className="storyfest-feature-header">
                <span className="storyfest-feature-num">{feature.num}</span>
                <h3 className="storyfest-feature-title">{feature.title}</h3>
              </div>
              <p className="storyfest-feature-desc">{feature.desc}</p>
            </div>
          ))}
        </div>

        {/* =========================================
            BOTTOM ACTION BAR
            ========================================= */}
        <div className="storyfest-overview-action-bar">
          <div className="storyfest-action-bar-text">
            <span className="storyfest-sparkle-icon"></span> There's a place for your story here.
          </div>
          
          <div className="storyfest-action-bar-buttons">
            {/* <button onClick={() => navigate('/vendors')} className="storyfest-btn-action storyfest-btn-gold-action">
              <span></span> Vendor registration <span className="storyfest-arrow">↗</span>
            </button> */}
            <button onClick={() => navigate('/register')} className="storyfest-btn-action storyfest-btn-outline-action">
              Register for Free to Experience StoryFest <span className="storyfest-arrow">→</span>
            </button>
            
            <button onClick={() => navigate('/believe')} className="storyfest-btn-action storyfest-btn-blue-action">
              <span></span> Believe tickets <span className="storyfest-arrow">↗</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default OverviewSection;